import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { SEARCH_ACTORS } from '@control-front-end/common/constants/graphActors';
import { RECENT } from 'constants';
import SelectEntityField from '../SelectEntityField';

/**
 * Выбор акторов
 */
function SelectActors(props) {
  const { exclude = [], excludeFormIds = [] } = props;
  const dispatch = useDispatch();
  const [actors, setActors] = useState([]);
  const excludeSet = exclude.map((i) => i.id);

  const saveActors = (data) => {
    const filterData = data.filter(
      (i) => !excludeSet.includes(i.id) && !excludeFormIds.includes(i.formId)
    );
    setActors(filterData);
  };

  const getData = () => {
    dispatch({
      type: RECENT.REQUEST,
      payload: { objTypes: 'actor' },
      callback: (data) => saveActors(data),
    });
  };

  const clearData = () => {
    setActors([]);
  };

  /**
   * Обработка поискового запроса
   */
  const handleSearch = (query) => {
    if (!query.length) {
      getData();
      return;
    }
    if (query.length < 2) return;
    dispatch({
      type: SEARCH_ACTORS.REQUEST,
      payload: { query, localState: true },
      callback: (data) => saveActors(data),
    });
  };

  return (
    <SelectEntityField
      {...props}
      objType="actor"
      multiselect={true}
      list={actors}
      onSearch={handleSearch}
      onFocus={() => getData()}
      onBlur={() => clearData()}
      onScroll={() => {}}
    />
  );
}

SelectActors.propTypes = {
  exclude: PropTypes.array,
  excludeFormIds: PropTypes.array,
};

export default SelectActors;
